import React from 'react';

const Awards = ()=> (
    <div>
        <h2>Best Paper Award</h2>
        <h3>Second-order Global Attention Networks for Graph Classification and Regression</h3>
        <p>Authors: Fenyu Hu, Zeyu Cui, Shu Wu, Qiang Liu, Jinlin Wu, Liang Wang, Tieniu Tan</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page6.png'} />
        <h2>Best Paper Runner-up Award</h2>
        <h3>Connecting Patients with Pre diagnosis: A Multiple Graph Regularized Method for Mental Disorder Diagnosis</h3>
        <p>Authors: Tianqi Zhao, Ming Kong, Kun Kuang, Zhengxing Huang, Qiang Zhu, Fei Wu</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page7.png'} />
        <h2>Finalist of Best Paper Award</h2>
        <h3>A Genetic Algorithm for Causal Discovery Based on Structural Causal Model</h3>
        <p>Authors: Zhengyin Chen, Kun Liu, Wenpin Jiao</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page8.png'} />
        <h2>Best Student Paper Award</h2>
        <h3>Visual Perception Inference on Raven's Progressive Matrices by Semi-Supervised Contrastive Learning</h3>
        <p>Authors: Aihua Yin, Weiwen Lu, Sidong Wang, Hongzhi You, Ru-Yuan Zhang, Da-Hui Wang, Zonglei Zhen, Xiaohong Wan</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page3.png'} />        
        <h2>Best Student Paper Runner-up Award</h2>
        <h3>3D Face Cartoonizer: Generating Personalized 3D cartoon Faces from 2D Real Photos with a Hybrid Dataset</h3>
        <p>Authors: Ming Guo, Shunfei Wang, Zhibo Wang, Ming Lu, Xiufen Cui, Xiao Ling, Feng Xu</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page4.png'} />        
        <h2>Finalist of Best Student Paper Award</h2>
        <h3>Deep Skill Chaining with Diversity for Multi-agent Systems</h3>
        <p>Authors: Zaipeng Xie, Cheng Ji, Yufeng Zhang</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page5.png'} />  
        <h2>Best Demo Award</h2>
        <h3>GLRNet: Gas Leak Recognition via Temporal Difference in Infrared Video</h3>
        <p>Authors: Erqi Huang, Linsen Chen, Tao Lv, Xun Cao</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page0.png'} /> 
        <h2>Best Demo Runner-up Award</h2>
        <h3>Contactless Cardiogram Reconstruction Based on the Wavelet Transform via Continuous wave Radar</h3>
        <p>Authors: Shuqin Dong, Changzhan Gu, Xiaokang Yang</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page1.png'} />         
        <h2>Finalist of Best Demo Award</h2>
        <h3>Artistic Portrait Applet, Robot, and Printer</h3>
        <p>Authors: Jingjie Zhu, Lingna Dai, Chenghao Xia, Chenyang Jiang, Weiyu Weng, Yiyuan Zhang, Jinglin Zhou, Fei Gao, Peng Li, Mingrui Zhu, Nannan Wang</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page2.png'} />     
        <h2>Outstanding Service</h2>
        <p>Kun Li</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page9.png'} />
        <h2>Outstanding Service</h2>
        <p>Mengqi Ji</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page10.png'} />
        <h2>Outstanding Service</h2>
        <p>Ruiping Wang</p>
        <img width="600" src={process.env.PUBLIC_URL + '/award-page11.png'} />           
    </div>
);

export default Awards;